import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Product } from 'src/app/classes/product';
import * as fa from '@fortawesome/free-solid-svg-icons';
import productUnits from 'src/app/constants/product-units';
import { Capacitor } from '@capacitor/core';
import { Prompt } from 'src/app/classes/prompt';
import { AiService } from 'src/app/services/ai.service';
import { Assignment } from 'src/app/classes/assignment';

@Component({
  selector: 'app-order',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss'],
})
export class ProductComponent implements OnInit, AfterViewInit {
  @ViewChild('promptInput') promptInput!: ElementRef
  @ViewChild('productRequest') productRequest!: ElementRef
  
  assignment = new Assignment()
  product = new Product();
  values!: any;
  fromAi = false
  number = 1;
  notes = '';
  productUnits = productUnits;
  noNext = false
  
  fa = fa
  animatedDots = ''
  agentResponse = ''
  firstPromptSent = false
  intervalId: any
  isTyping = false
  isMobile = /android|iphone|ipad|ipod|windows phone/i.test(navigator.userAgent)
  lastPrompt = ''
  now = new Date()
  platform = Capacitor.getPlatform()
  prompt!: Prompt
  placeholderText = $localize`What do you need done? Just tell me.`
  agentResponseProducts: any[] = []
  agentReponseAssignments: Assignment[] = []

  constructor(
    public activeModal: NgbActiveModal,
    private aiService: AiService
  ) { }

  ngOnInit() {
    if (this.values || this.fromAi) {
      this.number = this.values.number ?? 1;
      this.notes = this.values.notes ?? '';
    }

    // Enforce minimums
    if(this.number < this.product.order_quantity_min) {
      this.number = this.product.order_quantity_min;
    }

    this.aiService.prompt('customer_quantity_sales_agent').subscribe(result => {
      this.prompt = result as Prompt
    })


    this.intervalId = setInterval(() => {
      this.animatedDots = this.animatedDots + '.';
      if (this.animatedDots.length > 3) {
        this.animatedDots = '';
      }
    }, 500);

  }

  ngAfterViewInit() {
    this.promptInput.nativeElement.focus()

    if(this.lastPrompt) {
      this.promptInput.nativeElement.innerHTML = this.lastPrompt

      this.agentSend()
    }
  }

  ngOnDestroy() {
    clearInterval(this.intervalId);
  }

  agentSend() {
    const userPrompt = this.lastPrompt = this.stripHTML(this.promptInput.nativeElement.innerHTML)

    this.promptInput.nativeElement.innerHTML = ''
    this.agentResponse = ''
    this.firstPromptSent = true

    if (userPrompt.length > 0) {
      this.animatedDots = ''
      this.agentReponseAssignments = []
      this.agentResponseProducts = []

      this.aiService.quantitySalesAssistant(localStorage.getItem('sales_chat_id'), this.assignment.id, this.product.id, userPrompt).subscribe({
        next: (result) => {
          this.now = new Date()

          this.agentResponse = result.response

          this.notes = result.notes
          this.number = Math.max(result.quantity, this.product.order_quantity_min)
        },
        error: () => {
          this.agentResponse = $localize`I'm sorry, I couldn't process your request. Please try again.`
        }
      })
    }

    else {
      this.now = new Date()
      this.agentResponse = $localize`Please enter a message.`
    }
  }

  stripHTML(html: string) {
    // Replace <br> tags with new lines
    const withNewLines = html.replace(/<br\s*\/?>/gi, '\n');
    // Remove all other HTML tags
    const strippedText = withNewLines.replace(/<\/?[^>]+(>|$)/g, '');
    return strippedText.trim();
  }

  incrementNumber() {
    const newNumber = this.number + (this.product.order_quantity_step || 1);
    
    this.number = newNumber;
  }

  decrementNumber() {
    const newNumber = this.number - (this.product.order_quantity_step || 1);
    if (newNumber >= 1 && newNumber >= this.product.order_quantity_min) {
      this.number = newNumber;
    }
  }

  removeOrder() {
    if (!confirm($localize`Are you sure you want to remove this item from your order?`)) {
      return
    }

    this.number = 0
    this.notes = ''
    
    this.placeOrder({ next: false })
  }

  updateNumber() {
    if(this.number < this.product.order_quantity_min) {
      this.number = this.product.order_quantity_min;
      alert($localize`The minimum order quantity is: ` + this.product.order_quantity_min + `.`);
    }
  }

  placeOrder(options: { next: boolean }) {
    this.activeModal.close({ product_id: this.product.id, number: this.number, notes: this.notes, next: options.next });
  }
}
